import { isOptionsGroup } from "./auth-service-tools351.js";

function defaultOptionsFilter(_ref) {
  let {
    options,
    search,
    limit
  } = _ref;
  const parsedSearch = search.trim().toLowerCase();
  const result = [];

  for (let i = 0; i < options.length; i += 1) {
    const item = options[i];

    if (result.length === limit) {
      return result;
    }

    if (isOptionsGroup(item)) {
      result.push({
        group: item.group,
        items: defaultOptionsFilter({
          options: item.items,
          search,
          limit: limit - result.length
        })
      });
    }

    if (!isOptionsGroup(item)) {
      if (item.label.toLowerCase().includes(parsedSearch)) {
        result.push(item);
      }
    }
  }

  return result;
}

export { defaultOptionsFilter };